import CurrencyAPI from '../data/currency-api-client.js'
import CheckoutAPI from '../data/checkout-api-client.js'

export default class CurrencyService {
    static async getCurrencies () {
        try {
            const {
                data,
            } = await CurrencyAPI.getCurrencies()

            return data
        } catch (error) {
            console.error('Error fetching supported currencies:', error)
            throw error
        }
    }

    static async checkCurrency (code) {
        try {
            const {
                data,
            } = await CheckoutAPI.currencies(code)

            return data
        } catch (error) {
            throw error
        }
    }
}
